import React, { useEffect, useRef, useState } from 'react';
import styles from './StorySection.module.css';

const StorySection = () => {
  // Separate states and refs for two distinct scroll triggers
  const [timelineVisible, setTimelineVisible] = useState(false);
  const [chefVisible, setChefVisible] = useState(false);

  const timelineRef = useRef(null);
  const chefRef = useRef(null);

  const timelineData = [
    {
      title: "Since 2024",
      desc: "Since 2024, Baglami brings together flavours, cultures, and people, shaped by global inspiration and rooted in local ingredients"
    },
    {
      title: "The Food",
      desc: "The menu follows the seasons, letting ingredients lead while the kitchen refines each plate with care, clarity, and a sense of restraint."
    },
    {
      title: "Quality",
      desc: "Every ingredient is chosen with a focus on quality, from sourcing to service, quality remains central, ensuring intense flavour in every bite ."
    }
  ];

  useEffect(() => {
    const observerOptions = { threshold: 0.25 };

    const timelineObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setTimelineVisible(true);
    }, observerOptions);

    const chefObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setChefVisible(true);
    }, observerOptions);

    if (timelineRef.current) timelineObserver.observe(timelineRef.current);
    if (chefRef.current) chefObserver.observe(chefRef.current);

    return () => {
      timelineObserver.disconnect();
      chefObserver.disconnect();
    };
  }, []);

  return (
    <>
      {/* SECTION 1: OUR STORY & TIMELINE */}
      <section
        ref={timelineRef}
        className={`${styles.storyWrapper} ${timelineVisible ? styles.show : ""}`}
      >
        <div className={styles.container}>
          <h2 className={styles.mainTitle}>Our Story</h2>
          <div className={styles.timelineWrapper}>
            <div className={styles.line}></div>
            <div className={styles.timelineGrid}>
              {timelineData.map((item, index) => (
                <div
                  key={index}
                  className={styles.timelineItem}
                  style={{ transitionDelay: `${index * 150}ms` }}
                >
                  <div className={styles.starIcon}>✦</div>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2: CHEF DETAILS */}
      <section
        ref={chefRef}
        className={`${styles.chefWrapper} ${chefVisible ? styles.show : ""}`}
      >
        <div className={styles.container}>
          <div className={styles.chefGrid}>
            <div className={styles.imageCol}>
              <div className={styles.imgReveal}>
                <img src={'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/IMG_0490.JPG%20(1).jpg'} alt="Chef James Kohela" className={styles.chefImg} />
              </div>
              <span className={styles.caption}>Chef Rohit Vishnani</span>
            </div>

            <div className={styles.contentCol}>
              <h2 className={styles.chefTitle}>
                Get to know the chef
              </h2>
              <p className={styles.chefDesc}>
                Chef Rohit Vishnani is a culinary expert known for his modern, global approach to food. Raised in Pune, his connection to cooking started at home with family. He credits his mother and grandmother for inspiring him — “They expressed love through food, and I saw that from a young age.” Festivals and gatherings centered on cooking taught him that food is about diversity, emotion, and connection.
                <br />
                He later moved to the USA for his studies before his path shifted fully into professional kitchens. That cross-continental exposure shaped his perspective: Indian roots, American training, and a global palate.              </p>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default StorySection;